import React from 'react';
import { Alert } from '../../components';
import { useI18n } from '@whizz/react-i18n';
import CluedoSearch from '../../assets/Cluedo-Nudges-Teachers-Magnify.svg';

interface NoDataProps {
  alert?: boolean;
  noDataMessage?: string;
}

const NoData = ( { alert = false, noDataMessage }: NoDataProps): React.ReactElement => {

  const { translate } = useI18n();
  if (alert) {
    return (
      <Alert
        show
        type={'info'}
        disableIcon
        invert
        className={'mb-lg whitespace-pre-wrap'}
      >
        <div className={'flex items-center'}>
          <img src={CluedoSearch} />
          {translate('global.NO_DATA')}
        </div>
      </Alert>
    );
  }
  return (
    <div className={'my-md flex justify-center items-center'}>
      <img src={CluedoSearch} />
      <p className={'text-xl font-bold'}>{noDataMessage ?? translate('global.CHARTS.NO_DATA')}</p>
    </div>
  );
};

export default NoData;
